function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { FormGroup } from 'reactstrap';
import { useField, useFormikContext } from 'formik';
import IconsList from "../../../fontawesome";
import Icon from "../../common/icon";
import { t } from "../../../services/translator";
import { Error, Label } from "./..";
/**
 * @todo à revoir quand le temps s y pretera.
 */

var SelectIcon = function SelectIcon(props) {
  var name = props.name; // hook

  var _useField = useField({
    name: name
  }),
      _useField2 = _slicedToArray(_useField, 3),
      field = _useField2[0],
      meta = _useField2[1],
      helpers = _useField2[2];

  var _useFormikContext = useFormikContext(),
      submitCount = _useFormikContext.submitCount;

  var value = field.value;
  var setValue = helpers.setValue; // state

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      selection = _useState2[0],
      setSelection = _useState2[1];

  useEffect(function () {
    if (value) {
      if (typeof value === 'string') {
        setSelection({
          value: value,
          label: /*#__PURE__*/React.createElement(Icon, {
            name: value
          })
        });
      } else {
        setSelection(value);
      }
    }
  }, [value]);
  var getIconsOptions = useCallback(function () {
    var options = IconsList.map(function (icon) {
      return {
        value: icon.iconName,
        label: /*#__PURE__*/React.createElement(Icon, {
          name: icon.iconName
        })
      };
    });
    return options;
  }, []);
  return /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Label, {
    name: name
  }), /*#__PURE__*/React.createElement(Select, {
    options: getIconsOptions(),
    value: selection,
    placeholder: t('icon'),
    onChange: function onChange(option) {
      return setValue(option.value);
    },
    isClearable: true,
    invalid: (meta.touched || submitCount > 0) && meta.error !== undefined
  }), /*#__PURE__*/React.createElement(Error, {
    name: name
  }));
};

SelectIcon.propTypes = {
  name: PropTypes.string.isRequired
};
export default SelectIcon;